(() => {
  const SELECTOR = '[data-hh-lineup]';

  const initRail = (panel) => {
    if (!panel) return;

    const track = panel.querySelector('[data-hh-lineup-track]');
    const progress = panel.querySelector('[data-hh-lineup-progress]');
    const buttons = [...panel.querySelectorAll('[data-hh-lineup-direction]')];

    if (!track) return;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const update = () => {
      const maximum = maxScroll();
      const position = Math.min(maximum, Math.max(0, track.scrollLeft));

      if (progress) {
        progress.style.width = `${maximum ? 18 + (position / maximum) * 82 : 100}%`;
      }

      buttons.forEach((button) => {
        const direction = Number(button.dataset.hhLineupDirection);
        button.disabled =
          maximum <= 2 ||
          (direction < 0 ? position <= 2 : position >= maximum - 2);
      });
    };

    if (panel.dataset.hhLineupRailReady !== 'true') {
      panel.dataset.hhLineupRailReady = 'true';

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const items = [...track.querySelectorAll(':scope > .hh-lineup__item')];
          let distance = Math.max(240, track.clientWidth * .62);

          if (items.length > 1) {
            const measured = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
            if (measured > 0) distance = measured * 3;
          }

          track.scrollBy({
            left: Number(button.dataset.hhLineupDirection) * distance,
            behavior: 'smooth',
          });

          window.setTimeout(update, 380);
        });
      });

      track.addEventListener('scroll', update, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      }
    }

    requestAnimationFrame(update);
  };

  const init = (root) => {
    if (!root || root.dataset.hhLineupReady === 'true') return;
    root.dataset.hhLineupReady = 'true';

    const tabs = [...root.querySelectorAll('[data-hh-lineup-tab]')];
    const panels = [...root.querySelectorAll('[data-hh-lineup-panel]')];

    if (!tabs.length || !panels.length) return;

    const select = (tab) => {
      const key = tab.dataset.hhLineupTab;

      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.dataset.hhLineupPanel === key;
        panel.hidden = !active;

        if (active) {
          requestAnimationFrame(() => initRail(panel));
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        select(tab);
      });

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];

        select(next);
        next.focus();
      });
    });

    select(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
